<template>
  <div>
    <v-app-bar app dark dense src="../assets/bandera.jpg" prominent>
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
      <template v-slot:extension>
        <v-app-bar-nav-icon
          @click="abrir_drawer()"
          v-show="$vuetify.breakpoint.smAndDown"
        ></v-app-bar-nav-icon>
        <v-toolbar-title
          class="ml-1"
          style="cursor: pointer"
          @click="$router.push('/')"
        >
          <v-icon class="warning--text">mdi-basketball</v-icon>
          <span class="warning--text"> La Vinotinto del Basket</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!--       <v-list-item dense link router to="/" v-show="$vuetify.breakpoint.mdAndUp">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item> -->
        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/torneos"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>Torneos</v-list-item-title>
        </v-list-item>

        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/juegos"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>Juegos</v-list-item-title>
        </v-list-item>

        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/jugadores"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>Jugadores</v-list-item-title>
        </v-list-item>

        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/game_log"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>Game Log</v-list-item-title>
        </v-list-item>

        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/lideres"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>Líderes</v-list-item-title>
        </v-list-item>

        <!-- <v-list-item dense link router to="/lideres_juegos" v-show="$vuetify.breakpoint.mdAndUp">
          <v-list-item-title>Records</v-list-item-title>
        </v-list-item> -->
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              class="mt-2 white--text text--darken-2"
              dense
              v-show="$vuetify.breakpoint.mdAndUp"
            >
              <v-list-item-title v-bind="attrs" v-on="on">
                Records
              </v-list-item-title>
            </v-list-item>
          </template>

          <v-list color="grey darken-4">
            <v-list-item
              dense
              link
              router
              to="/records_individuales"
              v-show="$vuetify.breakpoint.mdAndUp"
            >
              <v-list-item-title>Individuales</v-list-item-title>
            </v-list-item>
            <v-list-item
              dense
              link
              router
              to="/records_equipo"
              v-show="$vuetify.breakpoint.mdAndUp"
            >
              <v-list-item-title>Equipo</v-list-item-title>
            </v-list-item>
            <v-list-item
              dense
              link
              router
              to="/rivales"
              v-show="$vuetify.breakpoint.mdAndUp"
            >
              <v-list-item-title>Rivales</v-list-item-title>
            </v-list-item>
            <v-list-item
              dense
              link
              router
              to="/coachs"
              v-show="$vuetify.breakpoint.mdAndUp"
            >
              <v-list-item-title>Entrenadores</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-list-item
          class="mt-2 white--text text--darken-2"
          dense
          link
          router
          to="/jugadores_ncaa"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-title>NCAA</v-list-item-title>
        </v-list-item>
      </template>
      
      <v-btn icon class="float-right" v-if="user" @click="doLogout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="primary--text">
          <v-list-item link router to="/">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item link router to="/torneos">
            <v-list-item-title>Torneos</v-list-item-title>
          </v-list-item>
          <v-list-item link router to="/juegos">
            <v-list-item-title>Juegos</v-list-item-title>
          </v-list-item>
          <v-list-item link router to="/jugadores">
            <v-list-item-title>Jugadores </v-list-item-title>
          </v-list-item>
          <v-list-item link router to="/game_log">
            <v-list-item-title>Game Log</v-list-item-title>
          </v-list-item>
          <v-list-item link router to="/lideres">
            <v-list-item-title>Lideres</v-list-item-title>
          </v-list-item>

          <!--    <v-list-item link router to="/lideres_juegos">
            <v-list-item-title>Records</v-list-item-title>
          </v-list-item> -->

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item dense>
                <v-list-item-title v-bind="attrs" v-on="on">
                  Records
                </v-list-item-title>
              </v-list-item>
            </template>

            <v-list color="primary">
              <v-list-item dense link router to="/records_individuales">
                <v-list-item-title>Individuales</v-list-item-title>
              </v-list-item>
              <v-list-item dense link router to="/records_equipo">
                <v-list-item-title>Equipo</v-list-item-title>
              </v-list-item>
              <v-list-item dense link router to="/rivales">
                <v-list-item-title>Rivales</v-list-item-title>
              </v-list-item>
              <v-list-item dense link router to="/coachs">
                <v-list-item-title>Entrenadores</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-list-item link router to="/jugadores_ncaa">
            <v-list-item-title>NCAA</v-list-item-title>
          </v-list-item>
          <!--  <v-list-item link router to="profile">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              
                Account
              
             </v-list-item-title>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    drawer: false,
    group: null,
    snackbar: false,
    mensaje: "",
    admins: [
      ["Management", "mdi-account-multiple-outline"],
      ["Settings", "mdi-cog-outline"],
    ],
  }),

  computed: {
    ...mapState("users", ["user"]),
  },

  methods: {
    async doLogout() {
      try {
        await this.$store.dispatch("users/doLogout");
        this.$router.push({ name: "auth" });
        this.snackbar = true;
        this.mensaje = "Se cerró la sesión";
      } catch (error) {
        console.log(error);
      }
    },
    abrir_drawer() {
      this.drawer = true;
      window.scrollTo(0, 0);
      drawer = true;
    },
    ir_torneos() {
      this.$router.push("/torneos");
    },
    ir_juegos() {
      this.$router.push("/juegos");
    },
    ir_jugadores() {
      this.$router.push("/jugadores");
    },
    ir_jugadores_totales() {
      this.$router.push("/jugadores_acumulado");
    },
    ir_lideres() {
      this.$router.push("/lideres");
    },
    ir_lideres_juegos() {
      this.$router.push("/records_individuales");
    },
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .v-application a {
    background-color: rgba(0, 0, 0, 0.25); /* Cambiado el valor de transparencia de 25% a 0.25 */
  }
}

.v-toolbar__title {
  min-width: 230px;
  font-size: 1.1rem;
}
.spacer {
  width: 100%;
}
.v-navigation-drawer {
  background-color: #753b42 !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: #ffffff;
}
.v-application .primary--text {
  color: #ffffff !important;
  caret-color: #5e2129 !important;
}

.v-toolbar--prominent:not(.v-toolbar--bottom) .v-toolbar__title {
  align-self: flex-start;
  padding-bottom: 0px;
  padding-top: 0px;
}

.v-toolbar__title[data-v-e0d06366] {
  min-width: 300px;
}

.v-list .v-list-item--active {
    color: #ffffff !important;
}
</style>